import React from 'react';
import StarIcon from '@assets/icons/header/star.svg';

import { BlueBytePointsWrapper, Points } from './styled.tsx';

interface Props {
    score: number;
}

const BlueBytePoints: React.FC<Props> = ({ score }) => (
    <BlueBytePointsWrapper>
        <StarIcon />
        <Points>{score} XP</Points>
    </BlueBytePointsWrapper>
);

export default BlueBytePoints;
